<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="false"
      :hasFilter="true"
      :hasAdd="true"
      @handleAdd="showAddModal"
      :title="$lang.azmoonLang.analysis_algorithm_component"
      :url="url"
      :html="false"
      ref="searchAnalysisAlgorithmComponent"
      @updatePermissions="updatePermissions"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="
            py-1
            mb-3
            border-bottom
            d-md-flex d-block
            align-items-center
            justify-content-between
          "
        >
          <div class="d-flex align-items-center">
            <span
              class="
                mr-1
                fs_1_3rem
                w_h_35
                border
                bg-light
                rounded-circle
                d-flex
                align-items-center
                justify-content-center
                text-info
              "
            >
              <mdicon name="calculator-variant" />
            </span>
            <b class="px-1 fs_1rem" v-html="generateParvandehTitle(item)" />
          </div>
          <small
            class="
              text-muted
              d-md-block d-flex
              align-items-center
              justify-content-between
            "
          >
            <div
              v-b-tooltip
              title="ثبت کننده"
              v-if="
                pathOr(null, ['created_by'], item) &&
                pathOr(null, ['created_by'], item) !== getFullName(item)
              "
            >
              <i class="fas fa-user mr-1" />
              <span v-text="pathOr('', ['created_by'], item)" />
            </div>
            <div v-b-tooltip title="زمان ایجاد">
              <i class="fas fa-clock mr-1" />
              <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
            </div>
          </small>
        </b-col>
        <b-col cols="12" md="12">
          <b-row>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.azmoonLang.component_value_formula" />:
              <span
                class="text-muted"
                v-text="pathOr(null, ['component_value_formula'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.azmoonLang.flexible_description_formula" />:
              <span
                class="text-muted"
                v-text="pathOr(null, ['flexible_description_formula'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.azmoonLang.fix_description" />:
              <span
                class="text-muted"
                v-text="pathOr(null, ['fix_description'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.azmoonLang.rank_group" />:
              <b-badge
                v-for="(rank, i) in pathOr([], ['rank_group'], item)"
                :key="i"
                variant="secondary"
                class="mr-2 fs_13"
                v-text="pathOr('', ['caption'], rank)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="12" class="py-1 mt-3 border-top">
          <b-row align-v="center" align-h="between" class="w-100 m-0">
            <b-col cols="12" md="auto" class="px-0" />
            <b-col cols="12" md="" class="text-right px-0">
              <b-button
                v-if="isAdmin(permissions)"
                class="mr-2"
                variant="outline-success"
                size="sm"
                @click="showEditModal(item)"
              >
                <mdicon name="playlist-edit" size="20" />
                <b v-text="$lang.edit" class="ml-1" />
              </b-button>
              <b-button
                v-if="isAdmin(permissions, ['admin'])"
                class="mr-2"
                variant="outline-danger"
                size="sm"
                @click="showConfirmModal(item)"
              >
                <mdicon name="trash-can-outline" size="20" />
                <b v-text="$lang.delete" class="ml-1" />
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="addEditModal"
      size="lg"
      ok-only
      hide-footer
      hide-header
    >
      <AddAnalysisAlgorithmComponent
        v-if="addEditModalMode === 'add'"
        :parentPermissions="permissions"
        :algorithmId="id"
        @close="addEditModal = false"
        @getData="getData"
      />
      <EditAnalysisAlgorithmComponent
        v-if="addEditModalMode === 'edit'"
        :parentPermissions="permissions"
        :id="itemId"
        :algorithmId="id"
        @close="addEditModal = false"
        @getData="getData"
      />
    </b-modal>
    <Confirm
      v-model="confirmModal"
      :title="$lang.remove_item"
      :description="confirmDescription"
      dynamicClass=""
      :loading="confirmLoading"
      :preventDefault="true"
      :cancel-title="$lang.no"
      :ok-title="$lang.yes"
      @cancel="confirmModal = false"
      @ok="removeItem"
    />
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import Confirm from "@/components/base/confirm";
import AddAnalysisAlgorithmComponent from "../components/AddAnalysisAlgorithmComponent.vue";
import EditAnalysisAlgorithmComponent from "../components/EditAnalysisAlgorithmComponent.vue";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "analysis-algorithm-component",
  inject: ["analysisAlgorithmComponentRepository"],
  components: {
    SearchCard,
    Confirm,
    AddAnalysisAlgorithmComponent,
    EditAnalysisAlgorithmComponent,
  },
  data() {
    return {
      id: this.$route.params.id,
      permissions: [],
      addEditModal: false,
      addEditModalMode: "add",
      itemId: null,
      confirmModal: false,
      confirmLoading: false,
    };
  },
  computed: {
    reeditConfirmCaption() {
      return `با انجام این کار <b class='text-primary'>تعداد دفعات ویرایش شده</b> این رکورد <b class='text-primary'>0</b> خواهد شد
      <br><br><b>آیا از اجرای فرایند اطمینان دارید ؟</b>`;
    },
    url() {
      return generateApiUrl(["azmoon", "algorithm_component"], [], {
        "algorithm_id[]": this.id,
      });
    },
    confirmDescription() {
      return `${this.$lang.change_kind_question_mesage}
      <br>
      <br>
      <strong>${this.$lang.are_you_sure_to_remove_item}</strong>`;
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    getData() {
      this.$refs.searchAnalysisAlgorithmComponent.getItems();
    },
    generateParvandehTitle(item) {
      const componentNumber = pathOr("", ["component_number"], item);
      const caption = pathOr("", ["caption"], item);
      return `${componentNumber}- ${caption}`;
    },
    showAddModal() {
      this.addEditModalMode = "add";
      this.addEditModal = true;
    },
    showEditModal(item) {
      this.addEditModalMode = "edit";
      this.itemId = pathOr(null, ["id"], item);
      this.addEditModal = true;
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    getFullName(item) {
      const name = pathOr("", ["person", "name"], item);
      const family = pathOr("", ["person", "family"], item);
      return `${name} ${family}`;
    },
    showConfirmModal(item) {
      this.itemId = pathOr(null, ["id"], item);
      this.confirmModal = true;
    },
    async removeItem() {
      try {
        this.confirmLoading = true;
        const response = await this.analysisAlgorithmComponentRepository.delete(
          this.itemId
        );
        this.$notify.success(response.data.message);
        this.confirmModal = false;
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
</style>
